import React, { useEffect } from 'react';
import { useStore } from '../../store/Store';
import { fetchData } from '../../store/ActionProgramas';
import { slugify } from '../../utils/utils';
import './Programa.css';
import PageLoading from '../../components/PageLoading';
import PageError from '../../components/PageError';

export const Programa = ({
  match: {
    params: { programa: programaSlug }
  }
}) => {
  const {
    state: { programas, loading },
    dispatch
  } = useStore();

  useEffect(() => {
    programas.length === 0 && fetchData(dispatch);
  }, []);

  const fillContent = () => {
    if (loading) return <PageLoading />;
    if (!programas)
      return <PageError error="No se pudieron obtener los programas." />;

    const programa = programas.filter(
      prog => slugify(prog.pregrado) === programaSlug
    )[0];
    console.log(programa);
    if (!programa) return 'No existe';

    return (
      <section id="Programa">
        <div className="iframeWrapper">
          <iframe className="iframe" src={programa.urlVideo}></iframe>
        </div>
        <div className="Programa__description">
          <div className="Programa__title">
            <h2>{programa.pregrado}</h2>
            <small>{programa.facultad}</small>
          </div>
          <h4>Descripción</h4>
          <article>{programa.descripcion}</article>
          {programa.urlUdea && (
            <a
              className="btn btn-secondary Programa__btnVerMas"
              href={programa.urlUdea}
              target="_blank"
            >
              Ver más información
            </a>
          )}
          {programa.regiones && (
            <div className="Programa__regiones">
              <p className="titulo">Puedes encontrar este programa en</p>
              <div className="Programa__regionesList">
                {programa.regiones.map(municipio => (
                  <p key={municipio}>{municipio}</p>
                ))}
              </div>
            </div>
          )}
        </div>
      </section>
    );
  };

  return fillContent();
};
